<template>
  <div id="GoTop" @click="GoTop()">
    <!-- <span class="glyphicon glyphicon-chevron-up"></span> -->
    <img class="icon-top" src="../assets/images/nav-top.png" alt="">
  </div>
</template>
<script>
export default {
  name: "GoTop",
  data() {
    return {
      flag: false
    };
  },
  methods: {
    GoTop() {
      // 存储开始滚动的时间戳，用于动画计时
      const startTime = Date.now();
      // 存储开始滚动时的位置
      const startPosition = window.scrollY;
      
      // 使用 requestAnimationFrame 实现平滑滚动
      function smoothscroll() {
        // 计算动画持续时间（已过去的时间）
        const duration = Date.now() - startTime;
        // 设置动画总时长（毫秒）
        const totalDuration = 500;
        
        if (duration < totalDuration) {
          // 使用缓动函数计算当前应滚动到的位置
          const progress = duration / totalDuration;
          // 使用 easeOutQuad 缓动函数，使滚动效果更加自然
          const easeProgress = progress * (2 - progress);
          const currentScroll = startPosition - (startPosition * easeProgress);
          
          window.scrollTo(0, currentScroll);
          window.requestAnimationFrame(smoothscroll);
        } else {
          // 动画结束后，确保精确滚动到顶部
          window.scrollTo(0, 0);
        }
      }
      
      // 开始动画
      window.requestAnimationFrame(smoothscroll);
    }
    // GoTop() {
    //   (function smoothscroll() {
    //     var currentScroll =
    //       document.documentElement.scrollTop || document.body.scrollTop;
    //     if (currentScroll > 0) {
    //       window.requestAnimationFrame(smoothscroll);
    //       window.scrollTo(0, currentScroll - currentScroll / 10);
    //     }
    //   })();
    // }
  }
};
</script>
<style scoped>
#GoTop {
  /* width: 50px;
  height: 50px; */
  position: fixed;
  right: 0px;
  bottom: 50px;
  z-index: 9999;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}
#GoTop > span {
  display: block;
  width: 100%;
  height: 100%;
  color: rgb(8, 162, 233);
  font-size: 30px;
}

.icon-top{
  width: 70px;
  height: 70px;
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue